<template>
  <div
    class="display-flex-center justify-content-between position-rel full-box"
  >
    <a
      href="javascript:;"
      class="
        primary-color
        font-size-16 font-sanpro-semibold
        book-viewer__footer__cats
        position-rel
        display-flex-center
        justify-content-center
      "
      @click="handleToggleBookCats"
      :class="{
        'btn-main-light-no-hover': openBookCats,
        'is-full border-rd-50': isShowBookFullScreen,
        'border-rd-20': !isShowBookFullScreen,
      }"
    >
      <i class="icon-category font-size-22" />
      <span v-if="!isShowBookFullScreen" class="only-pc">Mục lục</span>
    </a>
    <div
      class="book-viewer__paging display-flex-center"
      :class="{ 'full-size': isShowBookFullScreen }"
    >
      <!-- /** Fix page; Author: anhdd (6/7/2022)*/ -->
      <!-- <button
          class="d-none d-lg-block border-0 border-rd-50 text-center"
          :class="{'disabled': isFirstPage}"
          @click="firstPage"
        >
          <i class="icon-first-page font-size-20" />
        </button>
        <button
          class="border-0 border-rd-50 text-center display-flex-center"
          :class="{'disabled': disabledControls || isFirstPage}"
          @click="prevPage"
        > -->

      <!-- d-none  -->
      <button
        title="Chuyển đến trang đầu"
        class="d-lg-block border-0 border-rd-50 text-center"
        :class="{ disabled: isFirstPage }"
        @click="prevTopic"
      >
        <span class="next-first-page">|</span
        ><i class="icon-first-page font-size-20" />
      </button>
      <button
        :class="{ disabled: isFirstPost }"
        title="Quay lại bài trước"
        class="border-0 border-rd-50 text-center display-flex-center"
        @click="prevPage"
      >
        <i class="icon-first-page font-size-20" />
      </button>
      <div class="book-viewer__paging__input" @click="openInputChangePaging">
        <input
          type="number"
          ref="direct_page"
          class="border-0"
          v-model="inputPageDirect"
          v-show="actionWritePaging"
          @blur="directToPage"
          @keyup.enter="directToPage"
        />
        <span
          class="show-pages"
          v-if="displayTwoPage && !actionWritePaging && page > 1"
        >
          <span v-if="page % 2 === 0 && page === ebooksDetail.totalPage - 1">{{
            page
          }}</span>
          <span v-else-if="page % 2 === 0">{{ page }} - {{ page + 1 }}</span>
          <span v-else>{{ page - 1 }} - {{ page }}</span>
        </span>
        <span
          class="show-pages"
          v-else-if="!displayTwoPage && page > 1 && !actionWritePaging"
        >
          {{ page }}
        </span>
        <span class="show-pages text-center" v-else-if="isPage1">1</span
        ><!-- /** Fix page; Author: anhdd (6/7/2022)*/ -->
        <span class="show-pages text-center" v-else>0</span>
        <span class="show-pages show-pages--mobile">{{ page }}</span>
      </div>
      <button
        title="Chuyển đến bài tiếp theo"
        class="border-0 border-rd-50 text-center display-flex-center"
        :class="{ disabled: isLastPost }"
        @click="nextPage"
      >
        <i class="icon-last-page font-size-20" />
      </button>

      <!-- d-none  -->
      <button
        title="Chuyển đến trang cuối"
        class="d-lg-block border-0 border-rd-50 text-center"
        :class="{ disabled: isLastPage }"
        @click="nextTopic"
      >
        <i class="icon-last-page font-size-20" /><span class="next-last-page"
          >|</span
        >
      </button>
    </div>
    <div class="book-viewer__zoom-switch display-flex-center">
      <!-- Vị trí nút thu phóng và xem đơn đôi chưa đúng, phải đưa xuống dưới ngang hàng với nút next trang
      Author: anhdd (01/12/2022) -->
      <div class="book-viewer__switch">
        <div class="switch-viewpage full-width border-rd-20">
          <label
            class="view-single p-l-r-6"
            :class="{
              'active-tab-menu': displayTwoPage == false ? true : false,
            }"
            @click="changeViewBookNew(false)"
            title="Hiển thị 1 trang"
          >
            <img src="@/assets/images/one-page.png" />
          </label>
          <label
            class="view-double"
            :class="{
              'active-tab-menu': displayTwoPage == true ? true : false,
            }"
            @click="changeViewBookNew(true)"
            title="Hiển thị 2 trang"
          >
            <img src="@/assets/images/two-page.png" />
          </label>

          <label class="tab-search" @click="handleZoomBookOut">
            <img
              class="w-20"
              src="@/assets/images/zoom-out.png"
              title="Phóng to"
            />
          </label>
          <label
            class="tab-search"
            @click="handleZoomBookIn"
            style="margin-right: 5px"
          >
            <img
              class="w-20"
              src="@/assets/images/zoom-in.png"
              title="Thu nhỏ"
            />
          </label>
        </div>
      </div>
      <!-- ---------------------------- -->
      <a
        title="Chế độ xem toàn màn hình"
        href="javascript:;"
        class="
          book-viewer__changesize
          border-rd-50
          display-flex-center
          justify-content-center
          only-pc
        "
        :class="{ 'btn-main-light-no-hover': isShowBookFullScreen }"
        @click="handleChangeSizeScreen"
      >
        <i class="icon-full_screen font-size-18 primary-color" />
      </a>

      <!-- Fix bug: show icon trong mục cài đặt ( đổi thành 1-2 trang , phóng to thu nhỏ)
            ModifiedBy: anhdd (26/8/2022)
            -->
      <!-- <div
        class="
          book-viewer__setting
          position-rel
          border-rd-50
          display-flex-center
          justify-content-center
        "
      >
        <i
          class="
            book-viewer__setting__icon
            icon-setting
            font-size-18
            primary-color
          "
          :class="{ active: toggleSettingPopup }"
          @click="handleToggleModalSetting"
        />
        <div
          class="
            book-viewer__setting__popup
            bg-color-light
            border-rd-4
            effect-transition-fast
          "
        >
          <div class="book-viewer__zoom d-block text-center">
            <input
              type="range"
              min="1"
              max="200"
              v-model="zoomVal"
              title="Tùy chính kích cỡ trang sách"
              class="slider"
              id="myRange"
              @input="handleZoomEvt"
            />
            <div
              class="book-viewer__zoom__val secondary-color-txt font-size-14"
            >
              {{ zoomVal }} %
            </div>
          </div>
          <div class="book-viewer__switch only-pc">
            <div
              class="
                switch-viewpage
                full-width
                color_bg_gray_light
                border-rd-20
              "
            >
              <input
                :title="
                  cheDoXem == 2 ? 'Chế độ xem 2 trang' : 'Chế độ xem 1 trang'
                "
                type="checkbox"
                name="change_view"
                @change="changeViewBook"
                checked
              />
              <span class="bg-transition" />
              <label title="Chế độ xem 1 trang" class="view-single">
                <i class="icon-page-single" />
              </label>
              <label title="Chế độ xem 2 trang" class="view-double">
                <i class="icon-page-double" />
              </label>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { STORE_KEY } from "./../../_store/constants";
export default {
  name: "FooterBar",
  props: {
    page: Number,
    isPage1: Boolean /** Fix page; Author: anhdd (6/7/2022)*/,
    displayTwoPage: Boolean,
    ebooksDetail: Object,
    lastPageCat1: Number,
    lstPage: Array,
    scale: Number,
  },
  data() {
    return {
      actionWritePaging: false,
      openBookCats: false,
      zoomVal: 100,
      isFirstPage: true,
      disabledControls: false,
      isLastPage: false,
      inputPageDirect: "",
      isShowBookFullScreen: false,
      toggleSettingPopup: false,
      cheDoXem: 2,
      isFirstPost: true,
      isLastPost: false,
    };
  },
  watch: {
    page(newVal) {
      // console.log("page: " + newVal);
      this.isLastPage = newVal >= this.lastPageCat1;
      this.isFirstPage = newVal <= 1;
      if (this.lstPage && this.lstPage.length > 0) {
        this.isFirstPost = newVal <= this.lstPage[0].pageNo;
        this.isLastPost =
          newVal >= this.lstPage[this.lstPage.length - 1].pageNo;
      }

      // Sách mần non
      // ModifiedBy: anhdd (8/12/2022)
      if (
        this.ebooksDetail &&
        this.ebooksDetail.classNo == 0 &&
        this.displayTwoPage
      ) {
        this.changeViewBookNew(false);
      }
      //-------------
    },
  },
  methods: {
    changeViewBook(evt) {
      if (evt.target.checked) {
        this.cheDoXem = 2;
      } else {
        this.cheDoXem = 1;
      }
      this.$emit("changeViewBook", evt.target.checked);
      // Reset zoom
      this.zoomVal = 100;
      this.handleZoomEvt();
    },
    handleToggleBookCats() {
      this.openBookCats = !this.openBookCats;
      this.$emit("toggleCatsList", this.openBookCats);
    },

    handleZoomEvt() {
      this.$emit("zoom", this.zoomVal / 100);
    },

    directToPage(evt) {
      this.actionWritePaging = false;
      this.inputPageDirect = "";
      this.$emit("directToPage", evt.target.value);
    },

    prevTopic() {
      if (this.isFirstPage) {
        return;
      }
      this.directToPage({ target: { value: 1 } });
      this.isLastPage = false;
    },

    nextTopic() {
      if (this.isLastPage) {
        return;
      }
      this.directToPage({
        target: {
          value: this.ebooksDetail.limitPage,
        },
      });
      this.isLastPage = true;
      this.isFirstPage = false;
    },

    prevPage() {
      if (this.isFirstPage) {
        return;
      }
      let pageRedirect = 0;
      for (let i = this.lstPage.length - 1; i >= 0; i--) {
        if (this.lstPage[i].pageNo < this.page - 1) {
          pageRedirect = this.lstPage[i].pageNo;
          this.directToPage({ target: { value: pageRedirect } });
          return;
        }
      }
      this.$emit("prevPage", true);
    },
    nextPage() {
      if (this.isLastPage) {
        return;
      }
      let pageRedirect = 0;
      let page = this.cheDoXem == 2 ? this.page + 1 : this.page;
      for (let i = 0; i < this.lstPage.length; i++) {
        if (this.lstPage[i].pageNo > page) {
          pageRedirect = this.lstPage[i].pageNo;
          this.directToPage({ target: { value: pageRedirect } });
          return;
        }
      }
      this.$emit("nextPage", true);
    },

    handleChangeSizeScreen() {
      this.openBookCats = false;
      this.isShowBookFullScreen = !this.isShowBookFullScreen;
      this.$emit("changeFullSizeBook", this.isShowBookFullScreen);
    },

    openInputChangePaging() {
      this.actionWritePaging = true;
      this.inputPageDirect = "";
      this.$nextTick(() => {
        this.$refs.direct_page.focus();
      });
    },

    handleToggleModalSetting() {
      this.toggleSettingPopup = !this.toggleSettingPopup;
    },

    /** Vị trí nút thu phóng và xem đơn đôi chưa đúng, phải đưa xuống dưới ngang hàng với nút next trang
     * ModifiedBy: anhdd (29/11/2022)
     */
    handleZoomBookOut() {
      this.scale += 0.2;
      this.$emit("zoom", this.scale);
    },

    handleZoomBookIn() {
      if (this.scale > 0) {
        this.scale -= 0.2;
        this.$emit("zoom", this.scale);
      }
    },

    changeViewBookNew(value) {
      const self = this;
      self.$emit("changeViewBook", value);
      // Reset zoom
    },
  },
};
</script>

<style lang="scss" scoped>
%visible-popup-setting {
  -moz-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  transform-origin: bottom right;
}
.book-viewer {
  &__zoom {
    margin-bottom: 15px;
  }

  &__changesize {
    margin-right: 10px;
  }

  &__setting,
  &__changesize {
    width: 35px;
    height: 35px;
  }

  &__setting {
    &__popup {
      position: absolute;
      bottom: 110%;
      right: 10px;
      width: 175px;
      padding: 15px;
      box-shadow: 0 0 10px rgba($color_dark, 0.3);
      -webkit-box-shadow: 0 0 10px rgba($color_dark, 0.3);
      -moz-transform: scale(0);
      -webkit-transform: scale(0);
      transform: scale(0);
      transform-origin: bottom right;
    }

    &:hover {
      .book-viewer__setting__popup {
        @media screen and (min-width: 992px) {
          -moz-transform: scale(1);
          -webkit-transform: scale(1);
          transform: scale(1);
          transform-origin: bottom right;
        }
      }
    }

    &__icon {
      &.active {
        ~ .book-viewer__setting__popup {
          @media screen and (max-width: 991px) {
            -moz-transform: scale(1);
            -webkit-transform: scale(1);
            transform: scale(1);
            transform-origin: bottom right;
          }
        }
      }
    }

    // &:not(.active) {
    //   .book-viewer__setting__popup {
    //     -moz-transform: scale(0);
    //     -webkit-transform: scale(0);
    //     transform: scale(0);
    //     transform-origin: bottom right;
    //   }
    // }
  }

  &__paging {
    > * {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
    button,
    &__input {
      height: 30px;
    }
    button {
      @extend .bg-transparent;
      min-width: 30px;
      line-height: 36px;

      i,
      i:before {
        @extend .primary-color;
      }

      &:hover {
        @extend .btn-main-light-no-hover;
      }
    }
    &__input {
      width: 100px;
      line-height: 30px;
      @extend .border-rd-20;
      @extend .bg-color-light;
      border: 1px solid $color_light;
      overflow: hidden;
      @extend .text-center;
      * {
        @extend .secondary-color-txt;
        @extend .font-size-16;
      }
      &:hover {
        border-color: $primary_color;
      }
      input {
        @extend .border-rd-20;
        &:focus {
          border: 1px solid $primary_color;
        }
      }
    }
    input {
      @extend .border-0;
      @extend .full-box;
      @extend .text-center;
      &:active,
      &:focus,
      &:visited {
        outline: 0;
      }
    }
    .show-pages--mobile {
      display: none;
    }

    &.full-size {
      padding: 5px 8px;
      background: rgba($color_light, 0.3);
      @extend .border-rd-20;

      button {
        @extend .bg-color-light;
      }
    }

    @media screen and (max-width: 991px) {
      .show-pages {
        display: none;
        &--mobile {
          display: block;
        }
      }
    }
  }
}
.slider {
  -webkit-appearance: none;
  @extend .full-width;
  @extend .color_bg_gray_light;
  height: 10px;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  border-radius: 4px;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    background: $primary_color;
    border-radius: 50%;
    cursor: pointer;
  }
  &::-moz-range-thumb {
    width: 15px;
    height: 15px;
    background: $primary_color;
    border-radius: 50%;
    cursor: pointer;
  }
}
.next-last-page {
  position: absolute;
  top: 17px;
  color: #0f3dba;
}
.next-first-page {
  position: absolute;
  top: 16px;
  margin-left: -4px;
  color: #0f3dba;
}
.switch-viewpage {
  height: $height_btn;
  @extend .position-rel;
  @extend .border-rd-20;
  @extend .display-flex-center;
  @extend .justify-content-between;

  input {
    position: absolute;
    top: 0;
    left: 0;
    @extend .full-box;
    opacity: 0;
    cursor: pointer;
    z-index: 2;

    &:checked ~ .bg-transition {
      transform: translateX(100%);
      -webkit-transform: translateX(100%);
      -moz-transform: translateX(100%);
      -ms-transform: translateX(100%);
      -o-transform: translateX(100%);
    }
    &:not(:checked) ~ label.view-single {
      transform: translateX(0px);
      -webkit-transform: translateX(0px);
    }
    &:checked ~ label.view-double i:before,
    &:not(:checked) ~ label.view-single i:before {
      @extend .primary-color;
    }
  }
  .bg-transition {
    background: $btn_color_1;
    position: absolute;
    top: 0;
    z-index: 0;
    @extend .border-rd-20;
    @extend .display-block;
    @extend .effect-transition-fast;
  }
  .bg-transition,
  label {
    width: 50%;
    height: 30px;
  }
  label {
    @extend .border-rd-20;
    @extend .secondary-color-txt;
    @extend .margin-0;
    @extend .effect-transition-fast;
    @extend .display-flex-center;
    @extend .justify-content-center;
    cursor: pointer;
    z-index: 1;
  }
}
@media screen and (max-width: 575px) {
  .book-viewer {
    &__footer {
      &__cats {
        &:not(.is-full) {
          min-width: 35px;

          i {
            margin-right: 0;
          }
        }
      }
    }

    &__paging {
      &__input {
        width: 50px;

        .show-pages {
          min-width: 50px !important;
        }
      }

      > * {
        &:not(:last-child) {
          margin-right: 5px;
        }
      }
    }
  }
}

.w-20 {
  width: 20px;
}
.p-l-r-6 {
  padding: 0 6px;
}
.active-tab-menu {
  background: $btn_color_1;
}
.tab-search {
  cursor: pointer;
}
.tab-search:hover {
  background: $btn_color_1;
}
.switch-viewpage label {
  margin-right: 12px;
}
</style>
